module.exports = __webpack_public_path__ + "static/barlow-semibold-webfont-1dfd7c3ce2705cb5f4c207e550d23eff.ttf";